
const getCountInCart = (state) => { 
    let total = 0;
    
    if(state === null)
        return total;

    total += getVirtualEventsCount(state.virtualEvents, "countInCart");
    
    total += !state.events ? 0 : state.events.reduce(
        (acc, currenEvent) => acc + currenEvent.squads.reduce(
        (nestedAcc, currentSquad) => nestedAcc + (!currentSquad.countInCart ? 0 : parseInt(currentSquad.countInCart, 10)), 0), 0);

    return isNaN(total) ? 0: total;
};
const getCountInReviewCart = (state) => { 
    let total = 0;
    
    if(state === null)
        return total;

    total += getVirtualEventsCount(state.virtualEvents, "quantity");

    total += !state.squads ? 0 : state.squads.reduce(
        (acc, squad) => acc + (!squad.countInCart ? 0 : parseInt(squad.countInCart, 10)), 0);

    return isNaN(total) ? 0: total;
};

const getVirtualEventsCount = (virtualEvents, key) => {
    return !virtualEvents ? 0 : virtualEvents.reduce(
        (acc, currentVirtualEvent) => acc + 
            (!currentVirtualEvent[key] ? 0 : parseInt(currentVirtualEvent[key], 10)), 0);
};

export {
    getCountInCart,
    getCountInReviewCart
};


// WEBPACK FOOTER //
// ./src/features/shared/util/getCountInCart.js